import * as angular from 'angular';
import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, GroupsResource, Alert) {
        this.$state = $state;
        this.GroupsResource = GroupsResource;
        this.Alert = Alert;

        this.st = new SmartTable();

    }

    $onInit() {
        let attribs = [];
        for(let key in this.customAttributes) {
            attribs.push({name: key, value:this.customAttributes[key]})
        }
        this.$attribs = angular.copy(attribs);
        this.attribs = angular.copy(attribs);
    }

    save() {
        this.isSaving = true;

        var attribsMap = this.attribs.reduce(function(map, obj) {
            map[obj.name] = obj.value;
            return map;
        }, {});
        this.GroupsResource
            .updateCustomAttributes(this.companyId, this.group.id, attribsMap)
            .then(() => {
                this.$state.go('.',{},{reload:'.'});
                this.Alert('success', 'company.user-directories.custom-attributes.saved');
            })
            .finally(() => this.isSaving = false)
    }

    validateAttributes() {
        let names = [];
        for(let attrib of this.attribs) {
            if(attrib.name.length == 0 || attrib.value.length == 0) {
                return false;
            }
            if(names.includes(attrib.name)) {
                return false;
            }
            names.push(attrib.name);
        }
        return true;
    }

    add() {
        this.attribs.push({name: '', value: ''})
    }

    saveDisabled() {
        return this.notModified() || !this.validateAttributes();
    }

    notModified() {
        return angular.equals(this.attribs, this.$attribs);
    }

    remove(attrib) {
        this.attribs = this.attribs.filter(a => a !== attrib);
    }

    reset() {
        this.attribs = angular.copy(this.$attribs);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/custom-attributes/group-custom-attributes.controller.js